import { render, staticRenderFns } from "./ProductShieldUser.vue?vue&type=template&id=5af2a62c&scoped=true&"
import script from "./ProductShieldUser.vue?vue&type=script&lang=js&"
export * from "./ProductShieldUser.vue?vue&type=script&lang=js&"
import style0 from "./ProductShieldUser.vue?vue&type=style&index=0&id=5af2a62c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af2a62c",
  null
  
)

export default component.exports